var a = 2;